import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetReporteCuarentena = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/reportes/cuarentena?empresa=${params.empresa}&partes=${params.partes}&inicio=${params?.inicio}&fin=${params.fin}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getReporteCuarentenaMutation: mutation.mutate,
  };
}